/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-expressions */
import React from 'react'
import { connect } from 'react-redux'
import { Modal, Button, Header, Icon } from 'semantic-ui-react'
import ItemActions from '../../../../reducers/itemReducer'
import ItemAndOptionPicker from './picker'
import Preview from './preview'

const styles = {
  headerWrapper: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  header: {
    display: 'flex',
    flex: 1
  },
  headerCloseButton: {
    display: 'flex',
    cursor: 'pointer'
  }
}

class ItemOptionLinkerModal extends React.Component {
  state = {
    tabIndex: 0,
    saving: false,
    selectedItemKeys: [],
    selectedItemOptionIds: []
  }

  tabTitles = ['Picker', 'Modify and Preview']

  setStateAsync = state => new Promise(resolve => {
    this.setState(state, resolve)
  })

  onSave = async () => {
    const { onClose, fetchItems, storeId } = this.props

    await this.setStateAsync({ saving: true })
    await this.PreviewFormRef.save()
    await this.setStateAsync({ saving: false })

    onClose()
    fetchItems(storeId)
    alert('Successfully linked items to options')
  }

  onItemClick = itemKey => {
    const { selectedItemKeys } = this.state
    const newSelectedItemKeys = selectedItemKeys.includes(itemKey)
      ? selectedItemKeys.filter(key => key !== itemKey)
      : selectedItemKeys.concat(itemKey)

    this.setState({ selectedItemKeys: newSelectedItemKeys })
  }

  onItemOptionClick = itemOptionId => {
    const { selectedItemOptionIds } = this.state
    const newSelectedItemOptionIds = selectedItemOptionIds.includes(itemOptionId)
      ? selectedItemOptionIds.filter(key => key !== itemOptionId)
      : selectedItemOptionIds.concat(itemOptionId)

    this.setState({ selectedItemOptionIds: newSelectedItemOptionIds })
  }

  onSelectAllPress = action => {
    if (action === 'deselect') {
      this.setState({ selectedItemKeys: [] })
    }

    if (action === 'select') {
      const { items, storeId} = this.props
      const storeItems = items[storeId] || {}
      const selectedItemKeys = Object.keys(storeItems)

      this.setState({ selectedItemKeys })
    }
  }

  renderActionButtons = () => {
    const { tabIndex, saving, selectedItemKeys, selectedItemOptionIds } = this.state
    const isSelectedItemEmpty = selectedItemKeys.length === 0
    const isSelectedOptionEmpty = selectedItemOptionIds.length === 0

    const disabled = saving || isSelectedItemEmpty || isSelectedOptionEmpty

    return (
      <React.Fragment>
        {
          tabIndex === 1 &&
          <Button
            icon
            onClick={() => this.setState({ tabIndex: 0 })}
            color="black"
            disabled={disabled}
          >
            <Icon name="arrow left" /> Previous
          </Button>
        }
        <Button
          icon
          onClick={() => {
            tabIndex === 0
              ? this.setState({ tabIndex: 1 })
              : this.onSave()
          }}
          color="black"
          loading={saving}
          disabled={disabled}
        >
          {
            tabIndex === 0
              ? <div><Icon name="arrow right" /> Next</div>
              : <div><Icon name="checkmark" /> Save</div>
          }
        </Button>
      </React.Fragment>
    )
  }

  render() {
    const { visible, items, storeId, itemOptions, onClose } = this.props
    const { tabIndex, selectedItemKeys, selectedItemOptionIds } = this.state
    const label = this.tabTitles[tabIndex]
    const storeItems = items[storeId] || {}

    return (
      <Modal open={visible} size="large" style={{ marginTop: 0 }}>
        <Modal.Header>
          <div style={styles.headerWrapper}>
            <div style={styles.header}>
              <Header content={label} />
            </div>
            <div style={styles.headerCloseButton}>
              <Icon name="close" color="red" onClick={onClose} />
            </div>
          </div>
        </Modal.Header>
        <Modal.Content style={{ height: 500, overflow: 'auto' }} className="branch-form">
          {
            tabIndex === 0
              ? <ItemAndOptionPicker
                items={storeItems}
                selectedItemKeys={selectedItemKeys}
                onItemClick={this.onItemClick}
                onItemOptionClick={this.onItemOptionClick}
                itemOptions={itemOptions}
                selectedItemOptionIds={selectedItemOptionIds}
                onSelectAllPress={this.onSelectAllPress}
              />
              : <Preview
                ref={ref => {this.PreviewFormRef = ref}}
                storeId={storeId}
                items={storeItems}
                selectedItemKeys={selectedItemKeys}
                itemOptions={itemOptions}
                selectedItemOptionIds={selectedItemOptionIds}
              />
          }
        </Modal.Content>
        <Modal.Actions>
          {this.renderActionButtons()}
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ itemOptions, items }, { storeId }) => ({
  itemOptions: itemOptions.data[storeId] || {},
  items: items.data,
})

const mapDispatch = {
  fetchItems: ItemActions.fetchItemsByRestaurant,
}

export default connect(mapState, mapDispatch)(ItemOptionLinkerModal)



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemOptionLinker/index.js